import WorkStripe from './WorkStripe';

export default WorkStripe;
